import { KoButton, KoForm, KoKanban, KoLoader, KoModal, KoText, KoToast, KoDP, KoTabs, KoTicketTable, KoBreadcrumb, KoEmpty, KoFlex, KoTitle } from "packages";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { getTicketBreadCrumb } from "shared/commonConstants";
import TaskCrud from "../task/crud";
import { DevelopmentAPI } from "../development.service";
import styles from './scrum.module.scss';
import { useSelector } from "react-redux";
import CommnetsModal from "shared/components/modals/comments";
import Radio from "antd/es/radio/radio";
import { workspaceAPI } from "pages/workspace/workspace.service";
import BulkUpdateCrud from "shared/components/tickettable/bulkUpdate";
const Scrum = ({profile}) => {
  const {workspaceId} = useParams();
  const userById = useSelector(state => state?.userById);
  const [isOpenCommentsModal, setCreateComment] = useState(false);
  const [workspaceObject, setWorkspaceObject] = useState();
  const [isLoading, setLoading] = useState(false);
  const [tickets, setTickets] = useState();
  const [currentRecord, setCurrentRecord] = useState();
  const [isBulkOpen, setBulkModal] = useState();
  const [activeTeam, setActiveTeam] = useState();
  const [isOpen, setModal] = useState(false);
  const [form] = KoForm.useForm();
  let userDetails = userById['data'];
  const [breadCrumbs, setBreadCrumbs] = useState();
  const [wosGroups, setWosGroups] = useState([]);

  const [subPagination, setSubPagination] = useState({
    size: 10,
    page: 1
  });
  const [subCurrentRecord, setSubCurrentRecord] = useState({
    status:1,
    issueType:2,
    priority:3,
    reporter: userDetails?.userId
  });
  const [openSubModel, setSubModel] = useState(false);
  const [isCommentsModel, setCommnetsModal] = useState(false);
  const [isSubLoading, setSubLoading] = useState(false);
  const [subTotalCount, setSubTotalCount] = useState(100);
  const [ subTickets ,setSubTickets] = useState();

  const [query ] = useState({
    sort: 'assigneeName:asc'
  });


 
  
  useEffect(()=>{
    if(workspaceId){
      getTicketWorkspace(workspaceId);
      getGroups(workspaceId);
    }
  },[workspaceId]);

  const getTicketWorkspace = (wosId, teamId) => {
    setLoading(true);
    DevelopmentAPI.getWorkspaceById(wosId).then(
      (data) => {
        setWorkspaceObject(data['project']);
        getTickets(data['project'], teamId);
        setLoading(false);
      },
      (err) => {
      }
    );
  };


  const getGroups = (workspaceId) => {
    workspaceAPI.getworkspaceGroups(workspaceId).then(
      (data) => {
        setWosGroups(data['groups']);
      },
      (err) => {
      }
    );
  };
  
  const handleChange = (teamId) => {
    setActiveTeam(teamId);
    if(teamId === 'all'){
      getTicketWorkspace(workspaceId, null);
    }else{
      getTicketWorkspace(workspaceId, teamId);
    }
   
  };

  

  const handleFinish = useCallback((values) => {
    setLoading(true);
    if(!values?.status){
      return;
    }
    DevelopmentAPI.createOrUpdateIssues(values, currentRecord?.ticketId, workspaceId).then(
      (data) => {
        setLoading(false);
        setModal(false);
        form.resetFields();
        KoToast.success(`Ticket ${currentRecord?.ticketId ? 'updated' : 'created'} successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  }, [form]);
  

  const onCardClick = (row, source) => {
    let rowObject = {...row, workspaceId: workspaceId};
    setCurrentRecord(rowObject);
    if(source === 'subtask'){
      setSubModel(true);
      getSubIssueById(row.ticketId);
    }else if(source === 'comments'){
      setCommnetsModal(true);
    }
   
  };

  const getCards = (tickets, wos) => {
    var mapped =tickets?.map(item => ({ 'id': item.ticketId, 'summary': item.summary, 'status': item.status, assigneeName: item.assigneeName, logo: item.logo || null, ...item}) );
    const groups =mapped.reduce((groups, item) => {
      const group = (groups[item.status] || []);
      group.push(item);
      groups[item.status] = group;
      return groups;
    }, {});
    let wosbyId=  wos ? wos : workspaceObject;
    const initializeBoard = wosbyId?.template?.workflow
      ?.filter(status => status.label && status.label.trim() !== "")
      .map(status => ({
        id: status.value,
        label: status.label,
        background: status.background,
        color: status.color,
        cards: []
      }));
        
    const populateBoardWithTickets = (tickets) => {
      const board = { columns: initializeBoard };
      if (!tickets) return board;
      Object.entries(tickets).forEach(([status, cards]) => {
        const column = board.columns.find(col =>
          col.id === parseInt(status)
        );
        if (column) {
          column.cards = cards;
        }
      });
          
      return board;
    };
    const populatedBoard = populateBoardWithTickets(groups);
    return populatedBoard;
  };

  const addEveryoneNode = (data) => {
    if (!Array.isArray(data)) return data;
    const allTickets = data
      .flatMap(user => Array.isArray(user.tickets) ? user.tickets : []);
    const totalCount = data.reduce((sum, user) => {
      return sum + (user.totalCount || 0);
    }, 0);

    const everyone = {
      assignee: "everyone",
      assigneeName: "Everyone",
      logo: null,
      tickets: allTickets,
      totalCount: totalCount
    };
    return [everyone, ...data];
  };

  const enrichTicketsWithUserInfo = (data) => {
    if (!Array.isArray(data)) return data;

    return data.map(user => {
      if (!Array.isArray(user.tickets)) return user;

      const updatedTickets = user.tickets.map(ticket => ({
        ...ticket,
        assigneeName: user.assigneeName,
        logo: user.logo || null
      }));

      return {
        ...user,
        tickets: updatedTickets
      };
    });
  };

  const getTickets=(wos, teamId)=>{
    setLoading(true);
    if(teamId){
      query['groupId'] = teamId;
    }else{
      delete query['groupId'];
    }
    DevelopmentAPI.getIssuesByScrum(query, workspaceId).then(
      (res) => {
        setTickets();
        const withname= enrichTicketsWithUserInfo(res);
        const updatedData = addEveryoneNode(withname);
        let tickets = [];
        for (let index = 0; index < updatedData?.length; index++) {
          const element = updatedData[index];
          const cards = getCards(element?.tickets ? element?.tickets : [], wos);
          tickets.push({
            key: element?.assignee,
            label: <div className={styles.assignee}>
              {element?.['logo']?  <KoDP className={styles.dp} width={24} height={24} logo={element?.['logo']} /> :
                <div className={`${styles.circle}  ${element ?
                  element?.assigneeName?.charAt(0).toLowerCase() : 'a'}`}>
                  <KoText className={`${styles.letter} fs-size-11`} text={element?.assigneeName?.charAt(0)} />
                </div>}
              <div className={styles.info}>
                <KoTitle level={5} className={styles.text} ellipsis={true} text={`${element?.assigneeName}`} />
                <KoText className={styles.textTicket} ellipsis={true} text={`${element?.totalCount} Tickets`} />
              </div>
            </div>,
            children:cards ? <KoKanban
              initialBoard={cards}
              getTickets={()=>getTickets(workspaceId)}
              onCardDragEnd={UpdateStatus}
              onNewCardConfirm={draftCard => ({
                id: new Date().getTime(),
                ...draftCard
              })}
              onCardClick={onCardClick}
              onCellClick={onCellClick}
              workflow={wos?.template?.activityTypes}
              onCardNew={()=>{}}
            /> : <></>
          });
        }
        setTickets(tickets);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };



  const ModifyTheLabel = async(status) => {
    const statusObject = workspaceObject?.template?.workflow.find(item => item.label === status);
    return statusObject ? statusObject.value : null;
  };

  
  const UpdateStatus =async(newStatus) => {
    const {cardId, columnHeader, currentCardData} = newStatus;
    const newStatusValue = await ModifyTheLabel(columnHeader);
    if(!newStatusValue) return;

    const updatedValues = {
      ...currentCardData,
      status: newStatusValue
    };

   
    DevelopmentAPI.createOrUpdateIssues(updatedValues, currentCardData?.ticketId,  workspaceId)
      .then(
        (data) => {
          KoToast.success(`${cardId} status updated successfully`);
          getTicketWorkspace(workspaceId);
        },
        (err) => {
        }
      );
  };

  const getSubIssueById = (ticketId)=> {
    setSubLoading(true);
    DevelopmentAPI.getSubTaskIssuesWithQuery(subPagination, ticketId,  workspaceId).then(
      (data) => {
        setSubLoading(false);
        setSubTotalCount(data?.totalCount);
        setSubTickets(data?.tickets);
      },
      (err) => {
        setSubLoading(false);
      }
    );
  };

  const getIssueById = (ticketId, workspaceIdFromParam)=> {
    setLoading(true);
    DevelopmentAPI.getIssueById(ticketId, workspaceId || workspaceIdFromParam).then(
      (data) => {
        setLoading(false);
        setSubCurrentRecord(data?.issue);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onCellClick=(row)=>{
    setCurrentRecord(row);
    // const updatedRoomObj = { ...row, source: 'tickets' };
    // dispatch(setSelectedChatData(updatedRoomObj));
    // dispatch(setSelectedChatType('tickets'));
    let crums = getTicketBreadCrumb(row, workspaceObject);
    setBreadCrumbs(crums);
  };




  const onChangeSubStatus=(key)=>{
    let q =  subPagination;
    if(key){
      q['status'] = key.toString();
    }else{
      delete q?.['status'];
    }
   
    getSubIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubType=(key)=>{
    let q =  subPagination;
    if(key){
      q['issueType'] = key.toString();
    }else{
      delete q['issueType'];
    }
    getSubIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubPriority =(key)=>{
    let q =  subPagination;
    if(key){
      q['priority'] = key.toString();
    }else{
      delete q?.['priority'];
    }
   
    getSubIssueById(currentRecord.ticketId, q);
  };

  const onChangeSubAssignees =(key)=>{
    let q =  subPagination;
    if(key){
      q['assignee'] = key.toString();
    }else{
      delete q?.['assignee'];
    }
   
    getSubIssueById(currentRecord?.ticketId, q);
  };
  
  const onSubSearchText=(text)=>{
    let q = subPagination;
    q['search'] = text;
    getSubIssueById(currentRecord?.ticketId, q);
  };

  const onSubSort = (key, type) => {
    let q = subPagination;
    q['sort'] = `${key}:${type}`;
    getSubIssueById(currentRecord?.ticketId, q);
  };
   
  const onSubPagination = (page, other) => {
    const query = {
      size: other,
      page: page
     
    };
    const p = Object.assign(subPagination, query);
    setSubPagination(p);
    getSubIssueById(currentRecord?.ticketId, p);
  };

  return (
    <div className={`${styles.wrapper} profileSection`}>
      {isLoading && <KoLoader/>}
      <div className={styles.teams}>
        <KoTitle text="Teams" level={5} className={styles.title} />
        <div className={styles.teamsWrapper}>
          
          <Radio.Group   onChange={(e) => handleChange(e.target.value)}
            defaultValue={activeTeam} buttonStyle="solid">
            <Radio.Button  value="all">All</Radio.Button>
            {wosGroups?.map((team, index) => (
              <Radio.Button key={index} value={team.groupId}>{team.name}</Radio.Button>
            ))}
          </Radio.Group>
        </div>
      </div>
      {tickets?.length >0 ? <KoTabs  options={tickets} defaultActiveKey={['1']}  /> :
        <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
          <KoEmpty  icon={'EmptyTwoTone'} title="No active sprints found." subText="Create a new sprint to get started." />
        </KoFlex>
      }
      <KoModal
        title={ breadCrumbs ? <KoBreadcrumb items={breadCrumbs} />
          : (currentRecord?.ticketId) ? `Update Issue ${(currentRecord?.ticketId).toUpperCase()}` : `Create Issue`}
        centered
        open={isOpen}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => {setCurrentRecord(); setModal(false);form.resetFields(); }}
        onClose={() => {setCurrentRecord(); setModal(false); form.resetFields();}}
        width={'95vw'}
        height={'95vh'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setModal(!isOpen); form.resetFields();}} />,
          <KoButton key='create' type='primary' label={currentRecord?.ticketId ? `Update` : `Create`} onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <TaskCrud form={form} handleFinish={handleFinish} initialValues={subCurrentRecord} />
      </KoModal>

      <KoModal
        title={`Bulk Update`}
        centered
        open={isBulkOpen}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setBulkModal(false); form.resetFields();}}
        onClose={() => { setCurrentRecord(); setBulkModal(false); form.resetFields();}}
        width={780}
        // maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setBulkModal(!isBulkOpen); form.resetFields();}} />,
          <KoButton key='update' loading={isLoading} type='primary' label={ `Update`}
            onClick={() => form.submit()} />
        ]}
      >
        <BulkUpdateCrud initialValues={currentRecord} form={form} />
      </KoModal>

      <KoModal
        title={`${currentRecord?.ticketId } Subtasks Lists`}
        centered
        open={openSubModel}
        afterClose={() => { setSubCurrentRecord(); setBreadCrumbs();}}
        handleOk={() => { setSubCurrentRecord(); setSubModel(false); }}
        onClose={() => { setSubCurrentRecord(); setSubModel(false); }}
      // maskClosable={false}
        width={`95vw`}
        footer={[]}>
        <>
          {isSubLoading && <KoLoader  />}
          <KoTicketTable
            setModal={setModal}
            onSearchText={onSubSearchText}
            profile={profile}
            API={DevelopmentAPI}
            getIssueById={getIssueById}
            onSort={onSubSort}
            onChangeStatus={onChangeSubStatus}
            onChangeType={onChangeSubType}
            onChangePriority={onChangeSubPriority}
            onChangeAssignees={onChangeSubAssignees}
            setCommnetsModal={setCommnetsModal}
            setCurrentRecord={setSubCurrentRecord}
            isOpen={openSubModel}
            maxHeight={100}
            Bulk={{
              visible: false
            }}
            RowSelectionOption={{
              visible: false
            }}
            setBreadCrumbs={setBreadCrumbs}
            createBtn={false}
            tickets={subTickets}
            // columnsRight={columnsRight}
            // onCellClickExternal={onExtraClick}
            onPagination={onSubPagination}
            pagination={{page: subPagination.page, limit: subPagination.limit}}
            totalCount={subTotalCount} />
        </>
      </KoModal>

      {isCommentsModel && <CommnetsModal
        setCreateComment={setCreateComment}
        isCommentsModal={isOpenCommentsModal}
        classNameMain={styles.wrapperOverflow} isCommnetsModalOpen={isCommentsModel} setCommnetsModal={() => setCommnetsModal(false)}
        currentRecord={currentRecord} setCurrentRecord={setCurrentRecord} workspaceId={currentRecord?.workspaceId} ticketId={currentRecord?.ticketId} />}

    </div>
  );
};

export default Scrum;
